"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingEventType = void 0;
var BillingEventType;
(function (BillingEventType) {
    BillingEventType["ORDER_SHIPPED"] = "Order Shipped";
    BillingEventType["REMOVAL_SHIPPED"] = "Removal Shipped";
    BillingEventType["INBOUND_CREATED"] = "Inbound Label Created";
})(BillingEventType || (exports.BillingEventType = BillingEventType = {}));
//# sourceMappingURL=BillingEventType.js.map